//#region  Start Scope: Imports
import React, { Component } from 'react';
import propTypes from 'prop-types';
import { withRouter } from '~HOC';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { SortUpIcon, SortDownIcon } from '~svg';

//#endregion
class SortPanel extends Component {
  constructor(props) {
    super(props);
    //#region  State
    this.state = {
      //set default value sort type
      currentSort: 'price',
      sortType: {
        price: true,
        time: true,
        arrivetime: true,
        duration: true,
        point: true,
      },
    };
    //#endregion
  }
  //#region Start Scope: Functions
  //change sort parameteer and icons after each click
  changeSort = (sortBy) => {
    let { sortType } = this.state;
    sortType[sortBy] = !sortType[sortBy];
    this.setState({ currentSort: sortBy, sortType }, () => {
      this.props.sortFlight(
        sortBy,
        this.state.sortType[sortBy] ? 'asc' : 'desc',
      );
    });
  };

  //#endregion
  //#region  Render
  renderSort = (sortBy) => {
    let { sortType, currentSort } = this.state;
    return (
      <div
        className={`d-flex shadow-sm  w-100  border-0 cursor-pointer justify-content-start justify-content-lg-center  align-items-center  py-md-1 py-lg-2  ${
          this.props.language.direction === 'ltr'
            ? 'px-1 px-xl-2'
            : 'px-1  px-xl-4'
        }  ${
          currentSort === sortBy
            ? 'text-white bg-secondary  '
            : 'bg-white  text-dark'
        }`}
        style={{
          borderRadius: '50rem',
        }}
        onClick={() => this.changeSort(sortBy, sortType)}
      >
        <div className="d-flex px-1">
          {sortType[sortBy] ? (
            <SortUpIcon
              size={16}
              color={currentSort !== sortBy ? '#000' : '#fff'}
            />
          ) : (
            <SortDownIcon
              size={16}
              color={currentSort !== sortBy ? '#000' : '#fff'}
            />
          )}
        </div>
        <span className=" text-center text-nowrap font-weight-bold py-1 d-lg-block d-md-none d-none ">
          <FormattedMessage
            id={`booking.by${
              sortType[sortBy] ? 'ascending' : 'descending'
            }${sortBy}`}
          />
        </span>
        <div />
      </div>
    );
  };

  render() {
    let { availableFlightCount, notAvailsFlightCount, language } = this.props;
    return (
      <div className="d-flex font-small align-items-center justify-content-center bg-transparent font-xsmall font-xl-smaller font-xxl-msmall">
        <div className="d-lg-flex  text-nowrap flex-column justify-content-center align-items-start text-captalize font-weight-bold p-2 col-1 d-md-none d-none  d-lg-block">
          <div className="d-flex">
            <span className="text-secondary">{availableFlightCount}</span>
            <span
              className={`text-gray px-1   font-smaller text-start text-nowrap`}
            >
              {this.props.intl.formatMessage({
                id: 'booking.availsflight',
              })}
            </span>
          </div>
          <div className="d-flex">
            <span className="text-secondary">{notAvailsFlightCount}</span>
            <span className="text-gray px-1   font-smaller text-start text-nowrap">
              {this.props.intl.formatMessage({
                id: 'booking.noseatresult',
              })}
            </span>
          </div>
        </div>
        <div className="d-flex flex-lg-fill  flex-lg-row flex-column   flex-md-column col-lg-11 col-6 px-0 justify-content-end  align-items-center">
          <div
            className={`sort-panel-item d-flex  justify-content-center  ${
              language.direction === 'rtl' ? 'ml-2 ml-xl-3' : 'mr-2 '
            }`}
          >
            {this.renderSort('price')}
          </div>

          <div
            className={`sort-panel-item d-flex justify-content-center ${
              language.direction === 'rtl' ? 'ml-2 ml-xl-3' : 'mr-2 '
            }`}
          >
            {this.renderSort('time')}
          </div>

          <div
            className={`sort-panel-item d-flex justify-content-center ${
              language.direction === 'rtl' ? 'ml-2 ml-xl-3' : 'mr-2 '
            } `}
          >
            {this.renderSort('arrivetime')}
          </div>

          <div
            className={`sort-panel-item d-flex justify-content-center ${
              language.direction === 'rtl' ? 'ml-2 ml-xl-3' : 'mr-2 '
            }`}
          >
            {this.renderSort('duration')}
          </div>
          <div className={`sort-panel-item d-flex justify-content-center`}>
            {this.renderSort('point')}
          </div>
        </div>
      </div>
    );
  }
  //#endregion
}
function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}
//#region propTypes and defaultProps
SortPanel.propTypes = {
  sortFlight: propTypes.func,
};
SortPanel.defaultProps = {
  sortFlight: () => {
    console.error("sortPanel  component hasn't sortFlight function");
  },
};
//#endregion
export default injectIntl(connect(mapStateToProps)(withRouter(SortPanel)));
